import { Activity, CalendarDays, RefreshCw, Star, type LucideIcon } from 'lucide-react';
import type { AdoptionDriverKey } from './AdoptionTypes';

/** The lucide icon for each adoption driver — shared by the overview KPI tiles and the drivers drill-in charts. */
export const DRIVER_ICONS: Record<AdoptionDriverKey, LucideIcon> = {
    volume: Activity,
    frequency: CalendarDays,
    complexity: Star,
    consistency: RefreshCw,
};
